import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  content: string;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  title,
  content,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-brand-light/50 last:border-0" data-id="element-181">
      <button className="w-full py-5 flex justify-between items-center text-left focus:outline-none" onClick={onClick} aria-expanded={isOpen} data-id="element-182">
        <span className="font-heading font-semibold text-lg text-brand-text pr-4" data-id="element-183">
          {title}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="flex-shrink-0 text-brand-primary" data-id="element-184">
          <ChevronDownIcon size={24} data-id="element-185" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-186">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-187">
            <div className="pb-5 text-brand-text/80 leading-relaxed" data-id="element-188">
              {content}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
interface AccordionProps {
  items: {
    title: string;
    content: string;
  }[];
  className?: string;
}
export function Accordion({
  items,
  className = ''
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className={`bg-white rounded-2xl shadow-sm border border-brand-light/50 p-2 md:p-4 ${className}`} data-id="element-189">
      {items.map((item, index) => <AccordionItem key={index} title={item.title} content={item.content} isOpen={openIndex === index} onClick={() => handleToggle(index)} data-id="element-190" />)}
    </div>;
}